import React, { useState } from "react";

export const DECLINE_KIND_LABELS: Record<string, string> = {
  "no-material": "Does not carry this alloy",
  "no-size": "Carries the alloy, not this size or shape",
  "no-stock": "Out of stock / mill lead time only",
  "needs-info": "Asked a question back",
  policy: "Will not quote (minimums, account, policy)",
  other: "No quotable items in the reply",
};

export const DECLINE_KIND_CLASS: Record<string, string> = {
  "no-material": "bg-red-50 text-red-700",
  "no-size": "bg-orange-50 text-orange-700",
  "no-stock": "bg-amber-50 text-amber-800",
  "needs-info": "bg-sky-50 text-sky-800",
  policy: "bg-gray-100 text-gray-700",
  other: "bg-red-50 text-red-700",
};

/** "declined · does not carry this alloy" with the reason, and the vendor's words on click. */
export const VendorReply = ({
  status,
  declineKind,
  declineReason,
  responseSummary,
  responseText,
  responseFrom,
  respondedAt,
  compact = false,
}: {
  status: string;
  declineKind?: string | null;
  declineReason?: string | null;
  responseSummary?: string;
  responseText?: string | null;
  responseFrom?: string | null;
  respondedAt?: string | null;
  compact?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const declined = status === "declined";
  const kindLabel = declined && declineKind ? DECLINE_KIND_LABELS[declineKind] || declineKind : "";
  const line = declined
    ? declineReason || responseSummary || "Replied without quotable items"
    : responseSummary || "";
  const when = respondedAt ? ` (${new Date(respondedAt).toLocaleDateString()})` : "";
  if (!line && !responseText) return null;
  return (
    <span className={compact ? "text-xs" : "text-xs"}>
      {kindLabel && (
        <span className={`mr-1 rounded px-1.5 py-0.5 font-medium ${DECLINE_KIND_CLASS[declineKind || "other"]}`}>
          {kindLabel}
        </span>
      )}
      <span className="text-gray-600">
        {line}
        {when}
      </span>
      {responseText && (
        <>
          {" "}
          <button
            type="button"
            className="text-blue-700 hover:underline"
            onClick={(e) => {
              e.stopPropagation();
              setOpen((v) => !v);
            }}
          >
            {open ? "hide reply" : "show reply"}
          </button>
          {open && (
            <span className="mt-1 block max-h-64 w-full overflow-auto whitespace-pre-wrap rounded border border-gray-200 bg-gray-50 p-2 text-gray-800">
              {responseFrom && <span className="mb-1 block text-gray-500">From {responseFrom}</span>}
              {responseText}
            </span>
          )}
        </>
      )}
    </span>
  );
};
